/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import appConfig from 'app-config';
import { useTranslator, FormattedMessage } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useModal } from '@jutro/components';
import { FormModalPopover} from 'ml-components-platform-react';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { QuestionSetComponent, platformMessages } from 'ml-components-platform-react';
import { MLPropertyValuationService  } from 'ml-services-common-react';
import { convertToSentenceCase } from 'ml-portals-util-js';

import MLTooltipComponent from '../../ml-components-platform-react/MLTooltipComponent/MLTooltipComponent';
import MLReplacementCostSummaryPrintButtonComponent from '../MLReplacementCostSummaryPrintButtonComponent/MLReplacementCostSummaryPrintButtonComponent';
import metadata from './MLHOReplacementCostSummaryComponent.metadata.json5';
import messages from './MLHOReplacementCostSummaryComponent.messages';
import styles from './MLHOReplacementCostSummaryComponent.module.scss';

import aerialImageryPopup from './popup/aerialImageryPopup.metadata.json5';


import { IntlContext } from '@jutro/legacy/locale';


const COV_A_REPLACEMENTCOST_ALERT_NAME = 'coverageALimitUpdatedToReplacementCostValue';
const ROOF_AGE_CHANGE_ELIGIBILITY_REPLACEMENT = 'roofAgeChangeEligibilityReplacement';
const isQnB = appConfig.portalCode === 'QB';

function ReplacementCostTooltipComponent(props) {
    ReplacementCostTooltipComponent.propTypes = {
        isReplacementCostSelected: PropTypes.bool.isRequired,
        isCondo: PropTypes.bool.isRequired
    };

    const translator = useTranslator();
    const { isReplacementCostSelected, isCondo } = props;

    let content = '';
    if (isReplacementCostSelected) {
        content = translator(messages.functionalReplacementCostTooltipContent);
    } else if (isCondo) {
        content = translator(messages.condoReplacementCostTooltipContent);
    } else {
        content = translator(messages.replacementCostTooltipContent);
    }

    return (
        <MLTooltipComponent
            tooltipContent={content}
            tooltipLabel={isReplacementCostSelected ? translator(messages.functionalReplacementCostTooltipTitle) : translator(messages.replacementCostTooltipTitle)}
            tooltipHref={isReplacementCostSelected ? '/faq#difference-between-rc-and-market-value' : undefined}
            tooltipLink={isReplacementCostSelected ? messages.readMoreFaq : undefined}
            tooltipWrapperClassName={`${isQnB ? 'displayBlockQB' : ''}`}
            noWrapper
        />
    );
}

function MLHOReplacementCostSummaryComponent(props) {
    const modalApi = useModal();
    const isGPA = appConfig.portalCode === 'GPA';
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const {
        isCondo,
        accountName,
        onValueChange,
        dwellingConstructionModifiersML,
        isPolicyChange,
        replacementCost,
        submissionVM,
        onClickEditHomeDetailsButton,
        showErrors,
        onValidate,
        closeCovAAlert,
        id,
        updateWizardData,
        isCompRater,
        setDisableNextButton,
        choosenQuote
    } = props;
    const homeownerCoverablesVM = _.get(submissionVM, 'lobData.homeowners.coverables');
    const constructionDetailsVM = _.get(homeownerCoverablesVM, 'constructionDetails_ML');
    const valuationID = _.get(constructionDetailsVM, 'valuationID.value');
    const coveragePartType = _.get(homeownerCoverablesVM, 'coveragePartType_ML.value');
    const isDwelling = submissionVM.value?.isDwelling();
    const isLandlordHome = submissionVM.value?.isLandlordHome();
    const isLandlordCondo = submissionVM.value.isLandlordCondo();

    const isQuoteAndBuy = _.get(submissionVM, 'baseData.portalCode_ML.value') === 'QB'
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();

    const modifiersToAdd = ["HOP_PlumbingType_ML", "HOPWiringType_ML"]

    const hydrant1000FtValue = _.get(constructionDetailsVM, 'hydrantWithin1000Feet.value');
    const fireDistrictInitialValues = _.get(constructionDetailsVM, 'fireDistrictNames.value', []);
    const fireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', '');
    const addressMatch = _.get(constructionDetailsVM, 'matchUsing.value.code', undefined);
    const hasWaterSupply = _.get(constructionDetailsVM, 'waterSupply.value', undefined);
    const hasSplitPPC = _.get(constructionDetailsVM, 'splitPPC.value', undefined);
    const hasFireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', undefined);
    const[fireDistrictValues, setFireDistrictValues]  = useState(fireDistrictInitialValues);

    const fireDistrictDropdownValues = fireDistrictValues.length > 1
        ? fireDistrictValues
        : fireDistrictName
            ? [fireDistrictName]
            : [];

    const isRefreshBtnVisible = () => {
        return addressMatch?.toLowerCase() === 'z' && fireDistrictName !== '';
    };

    const isHydrantValueDisabled = () => {
        const val1 = addressMatch?.toLowerCase() === 'a' && !_.isUndefined(hasSplitPPC) && !_.isUndefined(hasWaterSupply) && hasWaterSupply == '-';
        const val2 = addressMatch?.toLowerCase() === 'z' && !_.isUndefined(hasSplitPPC) && fireDistrictName !== '';

        return !(val1 || val2);
    };

    const [selectedHydrantValue, setSelectedHydrantValue] = useState(hydrant1000FtValue);
    const [isFireDistrictEditable, setIsFireDistrictEditable] = useState((!fireDistrictName || fireDistrictName == '') && fireDistrictValues.length > 1);
    const [isHydrantEditable, setIsHydrantEditable] = useState(!isHydrantValueDisabled());
    const [isRefreshButtonVisible, setIsRefreshButtonVisible] = useState(isRefreshBtnVisible());
    
    const [selectedFireDistrictValue, setSelectedFireDistrictValue] = useState(fireDistrictDropdownValues.find(item =>
        item.split(';')[0].trim() === fireDistrictName
    ) || (fireDistrictName ?? ''));


    const npQuestionsSetToShow = ["HOPDwelllingHomeSharing_Ext", "HOPDwellingHomeSharingAirbnb_Ext", "HOP_PlumbingType_Ext", "HOPWiringType_Ext"];
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const offerings = _.get(submissionVM, 'lobData.homeowners.value.offerings');
    const isHomeOwnerOrLandLord = !isCompRater && homeownerCoverablesVM?.value?.roofValueFromNearmapInteg === true && (isDwelling || isLandlordHome);
    const {
        showProgressDialog,
        showErrorModal,
        hideProgressDialog
    } = MLModalService();

    const {
        clearBlockAlerts,
        addWarningAlert,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    useEffect(() => {
        setIsRefreshButtonVisible(isRefreshBtnVisible());
        setIsHydrantEditable(!isHydrantValueDisabled())
    }, [constructionDetailsVM, fireDistrictName, isRefreshButtonVisible, selectedHydrantValue]);

    const _filterQuestionSet = (qs) => {
        qs.answers = Object.keys(qs.answers)
            .filter((key) => npQuestionsSetToShow.includes(key))
            .reduce((obj, key) => {
                obj[key] = qs.answers[key];

                return obj;
            }, {});
    };

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;

        if (questionSetSyncing && questionSetSyncPromise) {
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();

                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);

                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 0);
        }

        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);

        return updatePromise;
    };

    const dwellingInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingAdditionalInfo.value[0]');
    const filteredDwellingInfoQuestionSetData = _.clone(dwellingInfoQuestionSetData);

    if (filteredDwellingInfoQuestionSetData) {
        _filterQuestionSet(filteredDwellingInfoQuestionSetData);
    }

    const dwellingConstructionInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingConstructionAdditionalInfo.value[0]');
    const filteredDwellingConstructionInfoQuestionSetData = _.clone(dwellingConstructionInfoQuestionSetData);

    if (filteredDwellingConstructionInfoQuestionSetData) {
        _filterQuestionSet(filteredDwellingConstructionInfoQuestionSetData);
    }

    const isGrandProtectSelected = (offerings) => {
        if (!offerings || !Array.isArray(offerings) || !choosenQuote) {
            return false;
        }
        return offerings.some((offering) => offering.branchCode === 'HOPGrandProtectHome_ML' && offering.branchPublicID === choosenQuote)
    }
    
    // DE333477 - Map SolarPanelsExists from NearMap solarPanelsExistsInd and default to false when unavailable.
    useEffect(() => {
        const existingSolarPanelsExists = _.get(constructionDetailsVM, 'solarPanelsExists.value');
        if (!_.isNil(existingSolarPanelsExists)) {
            return;
        }
        const solarPanelsExistsInd = _.get(constructionDetailsVM, 'solarPanelsExistsInd.value');
        _.set(
            constructionDetailsVM,
            'solarPanelsExists.value',
            _.isNil(solarPanelsExistsInd) ? false : solarPanelsExistsInd
        );
        refreshData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        const hasReplacementCost = !!constructionDetailsVM?.replacementCost?.value;
        const isSelected = !!constructionDetailsVM?.isReplacementCostSelected_ML?.value;
        const isGP = isGrandProtectSelected(offerings);

        if (hasReplacementCost && isSelected && isGP) {
            const timer = setTimeout(() => {
                showErrorModal(
                    translator(messages.replacementCostSelectedHeader),
                    translator(messages.replacementCostSelectedDescription)
                );
            }, 500);
            setDisableNextButton(true);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    const updateModifiersForNP = useCallback(() => {
        if (!isModernProduct) return;

        const copiedModel = viewModelService.clone(submissionVM);

        const dwellingMods = _.get(
            copiedModel,
            'lobData.homeowners.modifiers_ML.dwellingsModifiers_ML.value',
            []
        );

        const constructionMods = _.get(
            copiedModel,
            'lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML.value',
            []
        );

        const modsToMove = dwellingMods.filter((mod) =>
            modifiersToAdd.includes(mod.codeIdentifier_ML)
        );

        if (!modsToMove.length) return;

        const updatedDwellingMods = dwellingMods.filter(
            (mod) => !modifiersToAdd.includes(mod.codeIdentifier_ML)
        );

        const existingCodes = constructionMods.map((mod) => mod.codeIdentifier_ML);

        const newMods = modsToMove.filter(
            (mod) => !existingCodes.includes(mod.codeIdentifier_ML)
        );

        const updatedConstructionMods = [...constructionMods, ...newMods];

        _.set(
            copiedModel,
            'lobData.homeowners.modifiers_ML.dwellingsModifiers_ML.value',
            updatedDwellingMods
        );

        _.set(
            copiedModel,
            'lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML.value',
            updatedConstructionMods
        );

        updateWizardData(copiedModel);
    }, [isModernProduct, submissionVM, viewModelService, updateWizardData]);

    useEffect(() => {
        updateModifiersForNP();
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const getRoofInstalledYear = useCallback(() => {
        const minYear = _.get(constructionDetailsVM, 'yearBuilt.value')
        const maxYear = new Date().getFullYear();
        // _.range is not inclusive. Need to add -1 to get correct years
        const yearRange = _.range(maxYear, minYear-1);
        const years = yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));
        return years;
    },[constructionDetailsVM]);

    const onChangeRoofAge = (value, path) => {
        //US1054452
        writeValue(value, path)
        clearBlockAlerts(ROOF_AGE_CHANGE_ELIGIBILITY_REPLACEMENT);
        //US1095460
        if(homeownerCoverablesVM?.value?.roofValueFromNearmapInteg === true){
            homeownerCoverablesVM.value.roofValueFromNearmapOverriden = true;
        }

        if((submissionVM.value.isHomeOwners() || submissionVM.value.isLandlordHome())
	        && (submissionVM.value.baseData.jobType === 'PolicyChange')
            && submissionVM.futureRenewalBoundPeriodExist_ML.value === true
            && (value > _.get(constructionDetailsVM, 'yearBuilt.value'))){
            addWarningAlert(messages.roofAgeChangeEligibilityReplacement, ROOF_AGE_CHANGE_ELIGIBILITY_REPLACEMENT);
        }
    }

    const calculateDwellingAge = () => {
        if (constructionDetailsVM.yearBuilt.value !== undefined) {
            const currentYear = new Date().getUTCFullYear();
            return (currentYear - constructionDetailsVM.yearBuilt.value);
        }
    };
    _.set(constructionDetailsVM, 'dwellingAge.value', calculateDwellingAge());

    useEffect(() => {
        dwellingConstructionModifiersML.forEach((mod) => {
            if (mod?.savedFromPortal?.value && mod?.updated?.value && mod?.editMode_ML?.value) {
                _.set(mod, 'savedFromPortal.value', true);
                _.set(mod, 'updated.value', true);
                _.set(mod, 'editMode_ML.value', true);
            }
        });

        if (!!constructionDetailsVM.replacementCost.value && replacementCost && !isPolicyChange && getNumberOfAlerts(COV_A_REPLACEMENTCOST_ALERT_NAME) <= 0) {
            addWarningAlert(messages.covALimitUpdatedAlert, COV_A_REPLACEMENTCOST_ALERT_NAME);
        }

        _.set(constructionDetailsVM, 'savedFromPortal.value', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (closeCovAAlert) {
            clearBlockAlerts(COV_A_REPLACEMENTCOST_ALERT_NAME);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeCovAAlert]);

    const constructPolicyAddress = () => {
        const { policyAddress } = homeownerCoverablesVM;
        return `${[policyAddress.addressLine1.value, policyAddress.addressLine2.value, policyAddress.city.value, policyAddress.state.value.code, policyAddress.postalCode.value].join(" ").replace(/ +/g, " ")}`;
    };

    const formatDate = (date) => {
        const parsedDate = new Date(date.year, date.month, date.day);
        return moment(parsedDate).format('MM/DD/YYYY');
    };

    const showReplacementCostSummaryPrintButton = () => {
        const showButton = isGPA
            && constructionDetailsVM.valuationID
            && constructionDetailsVM.valuationID.value
            && constructionDetailsVM.valuationVersion
            && constructionDetailsVM.valuationVersion.value;

        return !!showButton;
    };

    const isCondoType = () => {
        return coveragePartType.code === 'hopcondo' || coveragePartType.code === 'hop_landlord_condo_ml';
    };

    const syncModifiers = (submissionData, modifiers) => {
        submissionData.forEach((mod) => {
            const oldMod = modifiers.value.find((value) => {
                return value.patternCode === mod.patternCode;
            });
            _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : mod.chosenTermValue);
            _.set(mod, 'savedFromPortal', true);
            _.set(mod, 'editMode_ML', true);
            if (mod.valueType === 'date') {
                _.set(mod, 'dateValue_ML', oldMod ? oldMod.dateValue_ML : null);
            }
        });
        _.set(modifiers, 'value', submissionData);

        updateWizardData(submissionVM);
    };

    const newBusinessSync = (copiedModel, validMods) => {
        _.set(copiedModel, 'lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML', validMods);
        const submissionLoadPromise = LoadSaveService.updateModifiers(copiedModel, isGPA && authHeader);
        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((submissionData) => {
            syncModifiers(submissionData.lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML, dwellingConstructionModifiersML);
            updateModifiersForNP();
        });
    };

    const endorsementSync = (copiedModel, validMods) => {
        _.set(copiedModel, 'lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML', validMods);
        const endorsementLoadPromise = EndorsementService.saveEndorsement([copiedModel], authHeader);
        showProgressDialog(platformMessages.syncing, endorsementLoadPromise);
        endorsementLoadPromise.then((endorsementData) => {
            syncModifiers(endorsementData.lobData.homeowners.modifiers_ML.dwellingConstructionModifiers_ML, dwellingConstructionModifiersML);
            updateModifiersForNP();
        });
    };

    const updateModifier = (mod) => {
        _.set(mod, 'updated.value', true);
        const validMods = [];
        // eslint-disable-next-line react/prop-types
        const copiedModel = _.cloneDeep(submissionVM.value);
        // eslint-disable-next-line react/prop-types
        for (let i = 0; i < dwellingConstructionModifiersML.children.length; i += 1) {
            const modifier = dwellingConstructionModifiersML.children[i];
            if (modifier.aspects.subtreeValid) {
                validMods.push(modifier.value);
            }
        }

        if (!constructionDetailsVM.aspects.subtreeValid) {
            copiedModel.lobData.homeowners.coverables.constructionDetails_ML = null;
        }

        if (!isPolicyChange) {
            newBusinessSync(copiedModel, validMods);
        } else {
            endorsementSync(copiedModel, validMods);
        }
    };

    const showHomeDetailsButtonContainer = () => {
        const showButton = constructionDetailsVM.valuationID
                && constructionDetailsVM.valuationID.value
                && constructionDetailsVM.valuationVersion
                && constructionDetailsVM.valuationVersion.value;
        return !!showButton;
    };

    const writeValue = async (value, changedPath) => {
        const path = 'lobData.homeowners.coverables';
        onValueChange(value, `${path}.${changedPath}`);
        if (changedPath === "constructionDetails_ML.underconstructionDwelling") {
            if (!isPolicyChange) {
                await LoadSaveService.updateDwellingField(submissionVM.quoteID.value, value, authHeader);
            }
            else {
                await EndorsementService.updateDwellingField(submissionVM.jobID.value, value, authHeader);
            }
            _.set(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.underconstructionDwelling.value', value);
            refreshData();
            syncDwellingInfoQuestionSets('Boolean');
        }
    };    

    const openImageryModal = () => {
        clearBlockAlerts('imagery');
        showProgressDialog(messages.loadingImagery)

        MLPropertyValuationService.getImageryLinkByQuoteNumber(submissionVM.quoteID.value, authHeader).then((url) => {
            hideProgressDialog()

            if(url === "") { 
                addWarningAlert(messages.imageryUnavailable, 'imagery')
                return;
            }

            const componentProps = {
                showHeader: false,
                showActionButton: false,
                cancelBtnLabel: messages.close,
                uiProps: aerialImageryPopup.pageContent,
                closeOnOverlayClick: true,
                closeOnEsc: true,
                getOverrideProps: () => {
                    return {
                        iframe: {
                            src: url
                        }
                    };
                }                            
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />)

        }, () => {
            hideProgressDialog()
            addWarningAlert(messages.imageryUnavailable, 'imagery')
        })
    }

    const resetValues = async () => {
        const ppcValues = !isPolicyChange
            ? await LoadSaveService.callVeriskIntegration(
                submissionVM.quoteID.value,
                authHeader
            )
            : await EndorsementService.callVeriskIntegration(
                submissionVM.jobID.value,
                authHeader
            );

        const newSubmissionVM = viewModelService.clone(submissionVM);

        _.set(
            newSubmissionVM,
            'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value',
            ppcValues?.hydrantWithin1000Feet
        );

        _.set(
            newSubmissionVM,
            'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value',
            ppcValues?.fireDistrictName
        );
        
        const hydrantValue = ppcValues?.hydrantWithin1000Feet;
        const fireDistrict = ppcValues?.fireDistrictName ?? '';
        const fireDistrictValues = ppcValues?.fireDistrictNames

        setSelectedHydrantValue(hydrantValue);
        setSelectedFireDistrictValue(fireDistrict);
        setFireDistrictValues(fireDistrictValues);
        setIsFireDistrictEditable((!fireDistrict || fireDistrict === '' || fireDistrict == undefined) && fireDistrictValues.length > 1);
        setIsRefreshButtonVisible(isRefreshBtnVisible());
        setIsHydrantEditable(!isHydrantValueDisabled());
        

        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value', hydrantValue);
        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value', fireDistrict);
        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.isFireDistrictNameEditable.value', !fireDistrict && fireDistrictValues.length > 1);

        updateWizardData(newSubmissionVM);

        refreshData();
    };

    const resolvers = {
        resolveComponentMap: {
            modifiercomponent: MLModifierComponent,
            replacementCostTooltipComponent: ReplacementCostTooltipComponent,
            mlReplacementCostSummaryPrintButtonComponent: MLReplacementCostSummaryPrintButtonComponent,
            questionset: QuestionSetComponent,
        },
        resolveCallbackMap: {
            resetValues
        }
    };

    const replacementCostSummaryButtonContainerRemoveMarginRight = () => {
        return (
            isQnB && !showReplacementCostSummaryPrintButton()
        )
    }

    const syncDwellingInfoQuestionSets = (qsQuestionType) => {
        setDisableNextButton(false);
        let syncPromise;
        const quoteId = isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value
        if (!isPolicyChange) {
            syncPromise = LoadSaveService.syncQuestionSetML(quoteId, [filteredDwellingInfoQuestionSetData], authHeader);
        }
        else {
            syncPromise = EndorsementService.syncQuestionSetML(quoteId, [filteredDwellingInfoQuestionSetData], authHeader);
        }

        syncPromise.then((updatedQuestionSets) => {
            const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');

            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', dwellingQs);
            updateWizardData(submissionVM);
            refreshData();
        });
    };

    const onChangeTypes = ['Boolean', 'Choice', 'Integer'];
    const onDwellingInfoValueChange = (aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
        if (onChangeTypes.includes(qsQuestionType)) {
            syncDwellingInfoQuestionSets(qsQuestionType);
        }
        else {
            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', aQuestionSetAnswersValue);
            refreshData();
        }
    };

    const syncDwellingConsstructionInfoQuestionSets = (qsQuestionType) => {
        setDisableNextButton(false);

        const quoteId = isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value
        let syncPromise;
        if (!isPolicyChange) {
            syncPromise = LoadSaveService.syncQuestionSetML(quoteId, [filteredDwellingConstructionInfoQuestionSetData], authHeader);
        }
        else {
            syncPromise = checkQuestionSetSync(() => EndorsementService.syncQuestionSetML(quoteId, [filteredDwellingConstructionInfoQuestionSetData], authHeader));
        }

        syncPromise.then((updatedQuestionSets) => {
            const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingConstructionAddInfo_Ext');

            _.set(submissionVM, 'lobData.homeowners.dwellingConstructionAdditionalInfo.value[0]', dwellingQs);
            refreshData();
        });
    };

    const onDwellingConsstructionInfoValueChange = (aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
        if (onChangeTypes.includes(qsQuestionType)) {
            syncDwellingConsstructionInfoQuestionSets(qsQuestionType);
        }
        else {
            _.set(submissionVM, 'lobData.homeowners.dwellingConstructionAdditionalInfo.value[0]', aQuestionSetAnswersValue);
            refreshData();
        }
    };

    const onBlur = (evt, object, qsQuestionType) => {
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;

        if (!onChangeTypes.includes(qsQuestionType) && !isTargetModal) {
            syncDwellingInfoQuestionSets(qsQuestionType);
        }
    };

    const isHomeShareAirBnbSelected = () => {
        const value = _.get(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0].answers.HOPDwellingHomeSharingAirbnb_Ext');
        if (value && value === "true") return true;
        return false
    };


    const checkSolarPanelField = () => {
        const value = _.get(constructionDetailsVM, 'solarPanelsExistsInd.value');
        if (value) {
            _.set(constructionDetailsVM, 'solarPanelsExists.value', value);
            return true;
        }
        return false;
    }

    const checkCMVValue = () => {
        const value = _.get(constructionDetailsVM, 'currentMarketValue.value');
        if (value && value % 1000 !== 0) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        if (isQnB) {
            if (!_.isNil(constructionDetailsVM.replacementCost.value)) {
                hideProgressDialog();
            } else {
                showProgressDialog(platformMessages.saveSubmission);
            }
        }
    }, [constructionDetailsVM])


    const overrideProps = {
        replacementCostContainer: {
            visible: !!constructionDetailsVM.replacementCost.value
        },
        replacementCostLabel: {
            content: isCondoType() ? translator(messages.condoReplacementCostLabel) : translator(messages.homeReplacementCostLabel)
        },
        replacementCostValue: {
            content: `$${intl.formatNumber(_.get(constructionDetailsVM, 'replacementCost.value', 0))}`
        },
        valuationIdValue: {
            content: valuationID
        },
        nameValue: {
            content: accountName.toLowerCase()
        },
        addressValue: {
            content: constructPolicyAddress()
        },
        calculatedDateValue: {
            content: formatDate(constructionDetailsVM.valuationDate.value)
        },
        replacementCostSummaryButtonContainer: {
            className: replacementCostSummaryButtonContainerRemoveMarginRight() ? "replacementCostSummaryButton" : 'replacementCostSummaryButton margin-right-20'
        },
        replacementCostSummaryPrintButton: {
            visible: showReplacementCostSummaryPrintButton(),
            constructionDetailsVM,
            jobId: _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value'),
            sessionId: _.get(submissionVM, 'sessionUUID.value') || _.get(submissionVM, 'sessionUUID_ML.value'),
            isPolicyChange
        },
        editHomeDetailsButtonContainer: {
            visible: showHomeDetailsButtonContainer()
        },
        editHomeDetailsButton: {
            onClick: onClickEditHomeDetailsButton,
            className: isQnB ? 'vertical-spacing-30 secondaryButton widthSmall' : 'vertical-spacing-30',
            content: isQnB ? convertToSentenceCase(translator(messages.editHomeDetails)) : translator(messages.editHomeDetails)
        },
        additionalQuestionsContainer: {
            visible: (!isCondoType() || (isCondoType() && isModernProduct)) && (!isCompRater || (isCompRater && (dwellingConstructionModifiersML.value.length > 0)))
        },
        heatingTypeContainer : {
            visible: !isCompRater,
            className: !isModernProduct ? 'additionalQuestionField vertical-spacing-35': ''
        },
        selectHeatingType: {
            className: isModernProduct ? "flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15 vertical-spacing-20" : ""
        },
        oilTankUndergroundContainer: {
            visible: _.get(constructionDetailsVM, 'primaryHeatingType.value.code', '') === 'oil' && !isCompRater,
            onValueChange: writeValue,
            value: _.get(constructionDetailsVM, 'oilTankUnderground.value'),
            className: isQnB ? 'vertical-spacing-35 oilTankContainerQB' : !isModernProduct ? 'vertical-spacing-35 oilTankContainer' : ''
        },
        oilTankUnderground: {
            className: isQnB ? 'vertical-spacing-35 oilTankContainerQB radioButtonQnB' : isModernProduct ? 'flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15 vertical-spacing-20 oilTankStyle' : 'vertical-spacing-35 oilTankContainer'
        },
        oilTankDecommissioned: {
            visible: constructionDetailsVM.oilTankUnderground.value === true,
            onValueChange: writeValue,
            value: _.get(constructionDetailsVM, 'oilTankDecommissioned.value'),
            className: isModernProduct ? 'flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15 vertical-spacing-20 oilTankStyle' : ''
        },
        roofUpgradeDateRowContainer: {
            visible: !isCompRater && (isDwelling || isLandlordHome),
            className: isModernProduct ? '' : 'roofUpgradeDate vertical-spacing-40'
        },
        roofUpgradeDateContainer: {
            className : isModernProduct ? 'flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15' : 'col-md-3 roofUpgradeDateContainer'
        },
        roofUpgradeDate: {
            availableValues: getRoofInstalledYear(),
            onValueChange: onChangeRoofAge,
            value: _.get(constructionDetailsVM,"roofUpgradeDateML.year.value"),
            label: isModernProduct ? translator(messages.roofUpgradeDateForNP) : translator(messages.roofUpgradeDate),
            className : isModernProduct ? 'flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15' : ''
        },
        dwellingConstructionModifiers: {
            modifier: dwellingConstructionModifiersML,
            showValidationErrors: showErrors,
            onValidate: onValidate,
            updateModifier: updateModifier,
            isHomeowners: true
        },
        replacementCostValueTooltip: {
            isCondo,
            isReplacementCostSelected: _.get(constructionDetailsVM, 'isReplacementCostSelected_ML.value')
        },
        valuadtionIdLabel: {
            content: translator(messages.valuationIdLabel)
        },
        nameLabel: {
            content: translator(messages.nameLabel)
        },
        addressLabel: {
            content: translator(messages.addressLabel)
        },
        calculatedDateLabel: {
            content: translator(messages.calculatedLabel)
        },
        imageryLink: {
            onClick: openImageryModal,
            visible: (isDwelling || isLandlordHome) && !isPolicyChange && !isQuoteAndBuy
        },
        dwellingType: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'dwellingType.aspects.required', false)
        },
        currentMarketValue: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'currentMarketValue.aspects.required', false),
            showErrors,
            required: isModernProduct && _.get(constructionDetailsVM, 'currentMarketValue.aspects.required', false),
            tooltip: {
                text: (<FormattedMessage
                    {...messages.cmvTooltip}
                    values={{
                        br: () => <br />,
                        p: chunks => <p>{chunks}</p>
                    }}
                />)
            }
        },
        dwellingClassification: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'dwellingClassification.aspects.required', false)
        },
        dwellingUnderConstruction: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'underconstructionDwelling.aspects.required', false),
            onValueChange: writeValue
        },
        typeofConstruction: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'underconstructionDwelling.value', false)
        },
        includeCovForPPandLossOfUse: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'underconstructionDwelling.value', false)
        },
        dwellingQuestionSet: {
            path: 'lobData.homeowners.dwellingAdditionalInfo.value[0]',
            value: isGPA ? filteredDwellingInfoQuestionSetData : [],
            visible: isGPA,
            onValueChange: onDwellingInfoValueChange,
            onBlur,
            onValidate,
            showErrors,
        },
        solarPanelsAtPremises: {
            visible: isModernProduct && _.get(constructionDetailsVM, 'solarPanelsExists.aspects.required', false)
        },
        underConstructionNotification: {
            visible: _.get(constructionDetailsVM, 'underconstructionDwelling.value', false)
        },
        homeSharingAirBnbSelectedNotification: {
            visible: isHomeShareAirBnbSelected()
        },
        dwellingConstructionQuestionSet: {
            path: 'lobData.homeowners.dwellingConstructionAdditionalInfo.value[0]',
            value: filteredDwellingConstructionInfoQuestionSetData,
            onValueChange: onDwellingConsstructionInfoValueChange,
            onBlur,
            onValidate,
            showErrors,
        },
        ppcContainer: {
            visible: isModernProduct && !isCompRater && (!_.isUndefined(hasSplitPPC) || addressMatch?.toLowerCase() === 'z')
        },

        hydrantWithin1000ft: {
            disabled: !isHydrantEditable,
            value: selectedHydrantValue,
            visible: !_.isUndefined(hasSplitPPC),
            onValueChange: (value) => {
                _.set(
                    constructionDetailsVM,
                    'hydrantWithIn1000Feet.value',
                    value
                );
                setSelectedHydrantValue(value)
                setIsHydrantEditable(!isHydrantValueDisabled())
            }
        },

        fireDistrict: {
            disabled: !isFireDistrictEditable,
            value: fireDistrictDropdownValues.find(item => item.split(';')[0].trim() === fireDistrictName) || fireDistrictName,
            visible: addressMatch?.toLowerCase() === 'z',
            availableValues: fireDistrictDropdownValues.map(item => ({
                code: item,
                name: item,
            })),
            onValueChange: (selectedValue) => {
                setIsFireDistrictEditable(false);
                const selectedFireDistrict =
                    typeof selectedValue === 'string'
                        ? selectedValue
                        : selectedValue?.code || selectedValue?.value || '';

                _.set(
                    constructionDetailsVM,
                    'fireDistrictName.value',
                    selectedFireDistrict
                );
                _.set(
                    constructionDetailsVM,
                    'isFireDistrictNameEditable.value',
                    false
                );
            }
        },
        refreshButton: {
            visible: isRefreshButtonVisible,
            onClick: resetValues,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={homeownerCoverablesVM}
            onValueChange={writeValue}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={styles}
            callbackMap={resolvers.resolveCallbackMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

MLHOReplacementCostSummaryComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    isCondo: PropTypes.bool.isRequired,
    accountName: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    dwellingConstructionModifiersML: PropTypes.arrayOf(PropTypes.shape({})),
    isPolicyChange: PropTypes.bool.isRequired,
    replacementCost: PropTypes.bool,
    showErrors: PropTypes.bool.isRequired,
    onClickEditHomeDetailsButton: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    closeCovAAlert: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isCompRater: PropTypes.bool.isRequired
};

MLHOReplacementCostSummaryComponent.defaultProps = {
    dwellingConstructionModifiersML: [],
    replacementCost: false,
    closeCovAAlert: false
};

export default MLHOReplacementCostSummaryComponent;
